document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const items = drawer.querySelector('[data-cart-drawer-items]');
  const scrollHint = drawer.querySelector('[data-cart-drawer-scroll-hint]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const total = drawer.querySelector('[data-cart-drawer-total]');
  const drawerCount = drawer.querySelector('[data-cart-drawer-count]');
  const savings = drawer.querySelector('[data-cart-drawer-savings]');
  const progress = drawer.querySelector('[data-cart-drawer-progress]');
  const discountForm = drawer.querySelector('[data-cart-drawer-discount-form]');
  const discountInput = drawer.querySelector('[data-cart-drawer-discount]');
  const discountStatus = drawer.querySelector('[data-cart-drawer-discount-status]');
  const discountRemove = drawer.querySelector('[data-cart-drawer-discount-remove]');
  const discountEntry = drawer.querySelector('[data-cart-drawer-discount-entry]');
  const couponApplied = drawer.querySelector('[data-cart-drawer-coupon-applied]');
  const couponCode = drawer.querySelector('[data-cart-drawer-coupon-code]');
  const couponBenefit = drawer.querySelector('[data-cart-drawer-coupon-benefit]');
  const couponContainer = drawer.querySelector('[data-cart-drawer-coupon]');
  const secondaryActions = drawer.querySelector('[data-cart-drawer-secondary-actions]');
  const threshold = Number(drawer.dataset.freeShippingThreshold || 199900);
  const root = window.Shopify?.routes?.root || '/';
  const moneyFormatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const money = (cents) => `${moneyFormatter.format(Number(cents || 0) / 100)} MXN`;
  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
  const reloadCartPage = () => {
    if (document.querySelector('[data-cart-root]')) window.location.reload();
  };

  function discountDetails(cart) {
    const amount = Math.max(0, Number(cart.total_discount) || 0, (Number(cart.original_total_price) || 0) - (Number(cart.total_price) || 0));
    const labels = [
      ...(cart.cart_level_discount_applications || []).map((discount) => discount.title),
      ...cart.items.flatMap((item) => (item.discounts || []).map((discount) => discount.title))
    ].filter(Boolean).filter((label, index, all) => all.indexOf(label) === index);
    return { amount, labels };
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No fue posible actualizar el carrito. Intenta de nuevo.');
    return response.json();
  }
  let renderVersion = 0;
  async function comparisonPrices(cart) {
    const prices = new Map();
    const handles = [...new Set(cart.items.map((item) => item.handle).filter(Boolean))];
    await Promise.all(handles.map(async (handle) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const product = await response.json();
        for (const variant of product.variants || []) prices.set(String(variant.id), Number(variant.compare_at_price) || 0);
      } catch (_) { /* Keep Shopify's original prices if product data is unavailable. */ }
      finally { clearTimeout(timer); }
    }));
    return prices;
  }
  function referenceLine(item, prices) {
    return Math.max(Number(item.original_line_price) || 0, Math.max(Number(item.original_price) || 0, prices.get(String(item.variant_id)) || 0) * item.quantity);
  }
  async function render(cart) {
    const version = ++renderVersion;
    const prices = await comparisonPrices(cart);
    if (version !== renderVersion) return;
    const referenceTotal = cart.items.reduce((sum, item) => sum + referenceLine(item, prices), 0);
    const totalSavings = Math.max(0, referenceTotal - cart.total_price);
    const count = document.querySelector('.ptc-header__cart-count');
    if (count) { count.textContent = cart.item_count; count.setAttribute('aria-label', `${cart.item_count} productos en el carrito`); }
    if (drawerCount) drawerCount.textContent = `· ${cart.item_count}`;
    const remaining = Math.max(0, threshold - cart.total_price);
    const progressPercentage = Math.min(100, cart.total_price / threshold * 100);
    progress.classList.toggle('is-complete', remaining === 0);
    progress.innerHTML = remaining
      ? `<div class="ptc-cart-drawer__progress-copy"><strong>Faltan ${money(remaining)} para envío gratis</strong><small>Meta ${money(threshold)}</small></div><div class="ptc-cart-drawer__progress-track" style="--ptc-cart-progress:${progressPercentage}%"><span></span><i>${Math.round(progressPercentage)}%</i></div>`
      : '<strong class="ptc-cart-drawer__progress-complete">Tu pedido tiene envío GRATIS</strong>';
    footer.hidden = cart.item_count === 0;
    if (scrollHint) scrollHint.hidden = cart.items.length <= 3;
    total.textContent = money(cart.total_price);
    const discountCodeApplication = (cart.cart_level_discount_applications || []).find((discount) => discount.type === 'discount_code');
    const savedCoupon = cart.attributes?._ptc_coupon_code || discountCodeApplication?.title || '';
    const benefit = discountDetails(cart);
    const hasCoupon = Boolean(savedCoupon);
    couponContainer.classList.toggle('has-coupon', hasCoupon);
    secondaryActions.classList.toggle('has-coupon', hasCoupon);
    if (hasCoupon) {
      couponCode.textContent = savedCoupon;
      couponBenefit.textContent = benefit.amount > 0
        ? `Ahorro actual: ${money(benefit.amount)}`
        : 'Se validará al finalizar la compra.';
      if (discountInput) discountInput.value = savedCoupon;
    } else {
      couponCode.textContent = '';
      couponBenefit.textContent = '';
      if (discountInput) discountInput.value = '';
    }
    savings.hidden = totalSavings <= 0;
    savings.innerHTML = totalSavings > 0 ? `<strong><span>Ahorras</span><span>${money(totalSavings)}</span></strong>` : '';
    if (!cart.items.length) { items.innerHTML = '<div class="ptc-cart-drawer__empty"><h3>Tu carrito está vacío</h3><p>Agrega equipo para comenzar.</p></div>'; return; }
    items.innerHTML = cart.items.map((item, index) => {
      const before = referenceLine(item, prices);
      const discounted = before > item.final_line_price;
      const percent = before > 0 ? Math.round((before - item.final_line_price) / before * 100) : 0;
      const price = `<div class="ptc-cart-drawer-item__price">${discounted ? `<s>${money(before)}</s>` : ''}<strong${item.final_line_price === 0 ? ' class="is-free"' : ''}>${item.final_line_price === 0 ? 'Gratis' : money(item.final_line_price)}</strong>${discounted ? `<span class="ptc-cart-drawer-item__badge">${percent > 0 ? `−${percent}%` : 'Oferta'}</span>` : ''}</div>`;
      const properties = Object.entries(item.properties || {})
        .filter(([key, value]) => key && !key.startsWith('_') && value !== null && value !== undefined && String(value).trim() !== '')
        .map(([key, value]) => `<li><span>${escapeHtml(key)}:</span> <strong>${escapeHtml(value)}</strong></li>`).join('');
      const propertiesHtml = properties ? `<ul class="ptc-cart-drawer-item__properties">${properties}</ul>` : '';
      const discounts = (item.discounts || []).map((discount) => `<small class="ptc-cart-drawer-item__discount">${escapeHtml(discount.title)}${discount.amount ? ` · −${money(discount.amount)}` : ''}</small>`).join('');
      const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=220` : '';
      return `<article class="ptc-cart-drawer-item"><a class="ptc-cart-drawer-item__media" href="${escapeHtml(item.url)}">${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}</a><div class="ptc-cart-drawer-item__content"><small class="ptc-cart-drawer-item__index">${String(index + 1).padStart(2, '0')} / ${String(cart.items.length).padStart(2, '0')}</small><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}${propertiesHtml}${price}${discounts}<div class="ptc-cart-drawer-item__quantity"><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity - 1}" aria-label="Reducir cantidad de ${escapeHtml(item.product_title)}">−</button><span aria-label="Cantidad">${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad de ${escapeHtml(item.product_title)}">+</button></div></div><button class="ptc-cart-drawer-item__remove" type="button" data-cart-change="${index + 1}" data-quantity="0">Eliminar</button></article>`;
    }).join('');
    items.scrollTop = 0;
  }
  async function refresh(open = false) { await render(await getCart()); if (open && !drawer.open) drawer.showModal(); }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-cart-link]');
    if (!link) return;
    event.preventDefault();
    try { await refresh(true); } catch (error) { window.alert(error.message); }
  }, true);
  drawer.querySelector('[data-cart-drawer-close]')?.addEventListener('click', () => drawer.close());
  discountEntry?.addEventListener('toggle', () => {
    secondaryActions?.classList.toggle('is-coupon-open', discountEntry.open);
  });
  drawer.addEventListener('click', (event) => { if (event.target === drawer) drawer.close(); });
  items.addEventListener('scroll', () => {
    if (!scrollHint) return;
    const reachedEnd = items.scrollTop + items.clientHeight >= items.scrollHeight - 12;
    scrollHint.hidden = reachedEnd || items.querySelectorAll('.ptc-cart-drawer-item').length <= 3;
  }, { passive: true });
  drawer.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.cartChange), quantity: Number(button.dataset.quantity) }) });
      if (!response.ok) throw new Error((await response.json()).description || 'No fue posible actualizar el carrito.');
      await refresh();
    } catch (error) {
      window.alert(error.message);
      button.disabled = false;
    }
  });
  discountForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const code = discountInput.value.trim();
    const button = discountForm.querySelector('button');
    discountStatus.classList.remove('is-error', 'is-success');
    if (!code) { discountStatus.textContent = 'Escribe un código de descuento.'; discountStatus.classList.add('is-error'); return; }
    button.disabled = true;
    discountStatus.textContent = 'Aplicando…';
    try {
      const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code, attributes: { _ptc_coupon_code: code } }) });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'No fue posible agregar el cupón.');
      await render(cart);
      const benefit = discountDetails(cart);
      if (benefit.amount > 0 || benefit.labels.length) {
        discountStatus.textContent = benefit.amount > 0 ? `Cupón aplicado. Ahorras ${money(benefit.amount)}.` : 'Cupón aplicado correctamente.';
        discountStatus.classList.add('is-success');
      } else {
        discountStatus.textContent = 'El código quedó guardado, pero aún no genera un descuento. Revisa sus condiciones; el envío gratis se refleja al calcular la entrega.';
        discountStatus.classList.add('is-error');
      }
      reloadCartPage();
    } catch (error) {
      discountStatus.textContent = error.message;
      discountStatus.classList.add('is-error');
    } finally { button.disabled = false; }
  });
  discountRemove?.addEventListener('click', async () => {
    discountRemove.disabled = true;
    discountStatus.classList.remove('is-error', 'is-success');
    discountStatus.textContent = 'Quitando cupón…';
    try {
      const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '', attributes: { _ptc_coupon_code: '' } }) });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'No fue posible quitar el cupón.');
      await render(cart);
      discountEntry.open = false;
      discountStatus.textContent = 'Cupón eliminado.';
      discountStatus.classList.add('is-success');
      reloadCartPage();
    } catch (error) {
      discountStatus.textContent = error.message;
      discountStatus.classList.add('is-error');
    } finally { discountRemove.disabled = false; }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax !== undefined) return;
    event.preventDefault();
    const submit = event.submitter;
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'No fue posible agregar el producto');
      await refresh(true);
      form.closest('[data-card-options-dialog]')?.close();
    } catch (error) { alert(error.message); }
    finally { if (submit) submit.disabled = false; }
  });
  document.addEventListener('cart:updated', async (event) => {
    const cart = event.detail?.cart;
    if (cart) await render(cart);
    else await refresh();
    if (event.detail?.couponCode && discountStatus) {
      discountStatus.classList.remove('is-error');
      discountStatus.classList.add('is-success');
      discountStatus.textContent = `Cupón ${event.detail.couponCode} guardado. Shopify validará sus condiciones al finalizar la compra.`;
    }
  });
});